export const RETURN_REASONS: { [key: string]: string } = {
  PRODUCT_NOT_FIT: 'Não Serviu',
  DIVERGENT_PRODUCT: 'Produto errado',
  PRODUCT_LESS_THAN_EXPECTED: 'Abaixo da expectativa',
  MANUFACTURINGFAULT: 'Produto com defeito',
  SMALL_PRODUCT: 'O produto ficou pequeno',
  LARGE_PRODUCT: 'O produto ficou grande',
  WRONG_PRODUCT_SIZE: 'Tamanho errado',
  WRONG_PRODUCT_MODEL: 'Modelo errado',
  ORDER_FROM_ANOTHER_CUSTOMER: 'Pedido de outra pessoa',
  DIVERGENT_PRODUCT_DESCRIPTION_OR_MEDIA:
    'Produto diferente do site - foto ou descrição',
  WRONG_PRODUCT_COLOR: 'Não gostei da cor',
  WRONG_PRODUCT_MATERIAL: 'Não gostei da qualidade do material',
  DIVERGENT_SITE_PRODUCT: 'O produto não era idêntico ao site',
  WRONG_PRODUCT_MODEL_WHEN_WEAR_SHOES: 'Não gostei do modelo ao prová-lo',
  UNCOMFORTABLE_PRODUCT: 'Produto desconfortável',
};
